import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'wonderbly-components/lib/Icon';

import { localiseUrl } from 'src/common/utils/format-localised-url';

import './AccountAction.scss';

const AccountAction = props => (
  <div>
    <a className="account-action" href={localiseUrl(props.country, '/account')}>
      <div className="account-action__text">{props.children}</div>
      <div className="account-action__icon">
        <Icon icon="user" />
      </div>
    </a>
  </div>
);

AccountAction.propTypes = {
  children: PropTypes.string.isRequired,
  country: PropTypes.object.isRequired,
  href: PropTypes.string.isRequired
};

export default AccountAction;



// WEBPACK FOOTER //
// ./src/client/js/view/components/HeaderII/AccountAction/AccountAction.js